import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Adresse from './Adresse.jsx'
import AdresseIcon from '../../../images/Adresse.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class AdresseList extends Component {
    state = {
        adresser: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getAdresser = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/adresse`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                adresser: [...this.state.adresser, ...data.adresser].sort(this.addressComparer),
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    addressComparer = (a, b) => {
        if (a.adressenavn == null || b.adressenavn == null) return 1;
        if (a.adressenavn != b.adressenavn) return a.adressenavn.localeCompare(b.adressenavn)
        if (a.nummer != b.nummer) return a.nummer - b.nummer;
        return a.bokstav.localeCompare(b.bokstav);
    }

    toggleAdresser = () => {
        if (this.props.antall == 0) return

        if (this.state.adresser.length == 0) {
            this.getAdresser()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    kopierAdresser = event => {
        event.stopPropagation()

        if (this.state.adresser.length == 0) return;
        const replacer = (key, value) => value === null ? '' : value
        const header = Object.keys(this.state.adresser[0])
        const csv = [
          header.join(','),
          ...this.state.adresser.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        ].join('\r\n')
        
        navigator.clipboard.writeText(csv)
    }   

    render() {
        const { t } = this.props
        var antallAdresser = this.state.continuationToken ? `${this.state.adresser.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleAdresser}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={AdresseIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('adresser')} ({antallAdresser})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    { this.state.isOpened &&
                    <div className="icon-image right tooltip" onClick={this.kopierAdresser}>
                        <i className="fa fa-clipboard"></i>
                        <div className="tooltip-content">{t('vis.kopieradresser')}</div>
                    </div> }
                </div>
                <div className={this.state.isOpened && this.state.adresser.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.adresser.map((a, index) => { return (<Adresse key={a.adresseId} adresse={a} antall={this.props.antall} isLast={index==this.state.adresser.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getAdresser}>
                                <span>{t('hent.adresser')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(AdresseList)